"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var ApplyFilterAction_1 = require("@/pages/search/actions/ApplyFilterAction");
var mapStateToProps = function (state) { return ({
    t: state.hfilter.t
}); };
var mapDispatchToProps = function (dispatch) { return ({
    onButtonClick: function (isApply) { return dispatch(ApplyFilterAction_1.default.onButtonClick(isApply)); },
}); };
var applyFilter = function (props) {
    var onBgClick = function (e) {
        if (e.target !== e.currentTarget)
            return;
        props.onButtonClick(false);
    };
    return (React.createElement("div", { onClick: onBgClick, className: "c-applypop" },
        React.createElement("div", { className: "c-applypop__box" },
            React.createElement("div", { className: "c-applypop__icon" },
                React.createElement("span", { className: "fal fa-exclamation-circle" })),
            React.createElement("div", { className: "c-applypop__title" }, props.t.applyFilter),
            React.createElement("div", { className: "c-applypop__caption" }, props.t.applyFilterCaption),
            React.createElement("div", { className: "c-applypop__actions" },
                React.createElement("a", { onClick: function (e) { e.preventDefault(); props.onButtonClick(false); }, href: "#", className: "c-applypop__action o-btn o-btn--flat" }, props.t.applyFilterNo),
                React.createElement("a", { onClick: function (e) { e.preventDefault(); props.onButtonClick(true); }, href: "#", className: "c-applypop__action o-btn o-btn--primary" }, props.t.applyFilterYes)),
            React.createElement("a", { onClick: function (e) { e.preventDefault(); props.onButtonClick(false); }, href: "#", className: "c-applypop__close" },
                React.createElement("span", { className: "fal fa-times" })))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(applyFilter);
